import { useParams } from 'react-router-dom';
import IndustryPage from './IndustryPage';
import { industries } from './data';
import NotFound from '../NotFound';

export default function IndustryRoute() {
  const { slug } = useParams<{ slug: string }>();

  if (!slug || !industries[slug]) {
    return <NotFound />;
  }

  return <IndustryPage data={industries[slug]} />;
}
